export function scrollToChatBottom(time = 500, force = false) {
    const chatContent = $(".g-chatform-content");
    if (!chatContent.length) {
        return;
    }

    chatContent.each(function () {
        const element = this;
        const $el = $(this);

        const autoEnabled = element.isAutoScrollEnabled !== false;
        const userInteracting = element.isUserInteracting === true;

        // Magnet logic: Detect if we're close enough to the bottom to justify a "snap"
        const threshold = 1000;
        const currentPosition = element.scrollTop + element.clientHeight;
        const distanceToBottom = element.scrollHeight - currentPosition;
        const isNearBottom = distanceToBottom < threshold;

        // Only scroll if auto-scroll is enabled and user isn't interacting, OR if we're forcing it
        if (force || (autoEnabled && !userInteracting && isNearBottom)) {
            if (time === 0) {
                // Direct scroll - no animation
                element.scrollTop = element.scrollHeight;
            } else {
                $el.stop().animate({ scrollTop: element.scrollHeight }, time);
            }
        }
    });

    if (force) {
        // Trigger scroll whenever any images (avatars, attachments, cards) finish loading
        chatContent.find("img").one("load error", function () {
            chatContent.each(function () {
                this.scrollTop = this.scrollHeight;
            });
        });

        // Staggered retries to ensure scroll stays at bottom after lazy-load / font / layout updates
        const delays = [50, 150, 300, 500, 800, 1200, 2000];
        delays.forEach((delay) => {
            setTimeout(() => {
                chatContent.each(function () {
                    this.scrollTop = this.scrollHeight;
                });
            }, delay);
        });
    }
}
